import transport from "../images/transport.svg"
import car from "../images/car.svg"
import freon from "../images/freon.svg"

export default [
  {
    icon: car,
    title: "ITP",
    text:
      "Echipa Chedra Tax efectueaza ITP-uri pentru toate marcile de vehicule si autovehicule.",
  },
  {
    icon: transport,
    title: "Vulcanizare",
    text:
      "Reparare anvelope, echilibrare roti, indreptare jante, montat jante, montat anvelope, demontare si montare roti si demontare si montare anvelope de pe janta.",
  },
  {
    icon: freon,
    title: "Incarcare freon",
    text:
      "Service-ul nostru de incarcare freon va propune un diagnostic complet al instalatiei de climatizare, tinanad cont de modelul masinii dumneavoastre si specificatiile constructorului",
  },
]
